import { render } from "./HFargu.vue?vue&type=template&id=22e8ace4&scoped=true"
import script from "./HFargu.vue?vue&type=script&lang=js"
export * from "./HFargu.vue?vue&type=script&lang=js"

import "./HFargu.vue?vue&type=style&index=0&id=22e8ace4&lang=scss&scoped=true"
import "./HFargu.vue?vue&type=style&index=1&id=22e8ace4&lang=css"

import exportComponent from "D:\\workCode\\PC\\web-backEnd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22e8ace4"]])

export default __exports__